import React, { createContext, FC, useContext } from 'react';
import { Tracker } from './Tracker';

export interface TrackerProviderProps {
  tracker: Tracker;
}

const TrackerContext = createContext<Tracker>({} as Tracker);

export function useTracker() {
  return useContext(TrackerContext);
}

export const TrackerProvider: FC<TrackerProviderProps> = ({
  tracker,
  children
}) => (
  <TrackerContext.Provider value={tracker}>{children}</TrackerContext.Provider>
);
